<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/expenses/expenses.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :exportCsv="exportCsv"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Gasto', plural:'Gastos'}"
      :key="moduleName"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useExpensesStore } from '@/store/expenses';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/expenses/expenses.config';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Expenses';
const preferencesStore = usePreferencesStore();
const expensesStore = useExpensesStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => expensesStore.fetchExpenses(params),
  {
    create: expensesStore.createExpense,
    update: (data) => expensesStore.updateExpense(data.id, data),
    remove: expensesStore.deleteExpense,
    exportCsv: () => Promise.resolve()
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => expensesStore.expenses);
</script>
